import { gql } from '@apollo/client';

export const SAVE_ORDER_REPRINT_LOG = gql`
    mutation SaveOrderReprintLog(
        $hubId: Long
        $warehouseId: Long!
        $neutralTrackingNumber: String!
        $reprintTrackingNumber: String
        $trackingNumber: String
        $accountId: Long
        $status: Int!
        $failureType: Int
        $failureReason: String
        $processingTimeMs: Long!
    ) {
        saveOrderReprintLog(
            hubId: $hubId
            warehouseId: $warehouseId
            neutralTrackingNumber: $neutralTrackingNumber
            reprintTrackingNumber: $reprintTrackingNumber
            trackingNumber: $trackingNumber
            accountId: $accountId
            status: $status
            failureType: $failureType
            failureReason: $failureReason
            processingTimeMs: $processingTimeMs
        )
    }
`;

export interface SaveOrderReprintLogVariables {
    hubId?: number;
    warehouseId: number;
    neutralTrackingNumber: string;
    reprintTrackingNumber?: string;
    trackingNumber?: string;
    accountId?: number;
    status: 1 | 2;
    failureType?: number;
    failureReason?: string;
    processingTimeMs: number;
}

export interface SaveOrderReprintLogResponse {
    saveOrderReprintLog: number;
}
